var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAddressCardPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.189 10.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c5c9f6",
    d: "M12.09,2.25H1.1A1.1,1.1,0,0,0,0,3.349v8.06a1.1,1.1,0,0,0,1.1,1.1H12.09a1.1,1.1,0,0,0,1.1-1.1V3.349A1.1,1.1,0,0,0,12.09,2.25Zm-8.06,2.2A1.465,1.465,0,1,1,2.565,5.914,1.467,1.467,0,0,1,4.03,4.448ZM6.595,9.871a.48.48,0,0,1-.513.44h-4.1a.48.48,0,0,1-.513-.44v-.44A1.442,1.442,0,0,1,3,8.112h.114a2.359,2.359,0,0,0,1.823,0h.114A1.442,1.442,0,0,1,6.595,9.431Zm5.129-1.209a.184.184,0,0,1-.183.183h-3.3a.184.184,0,0,1-.183-.183V8.3a.184.184,0,0,1,.183-.183h3.3a.184.184,0,0,1,.183.183Zm0-1.465a.184.184,0,0,1-.183.183h-3.3A.184.184,0,0,1,8.06,7.2V6.83a.184.184,0,0,1,.183-.183h3.3a.184.184,0,0,1,.183.183Zm0-1.465a.184.184,0,0,1-.183.183h-3.3a.184.184,0,0,1-.183-.183V5.364a.184.184,0,0,1,.183-.183h3.3a.184.184,0,0,1,.183.183Z",
    transform: "translate(0 -2.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddressCardPurple);
export default __webpack_public_path__ + "static/media/icon-address-card-purple.e1ec91a4b559ef481620afe118327c2a.svg";
export { ForwardRef as ReactComponent };